




















import { Component, Vue } from "vue-property-decorator";

@Component
class ModalAssetsPermissionRequire extends Vue {
  dialog = false;

  source = "";

  show(source) {
    this.source = source || "";
    this.dialog = true;
  }

  handleAuth() {
    this.$common.utils.helper.requestLogin(this);
  }

  mounted() {
    this.$root.$on(this.$rootEvents.ASSETS_FORBIDDEN, source => {
      this.show(source);
    });
  }
}
export default ModalAssetsPermissionRequire;
